import { render, staticRenderFns } from "./CompanyEventTable.vue?vue&type=template&id=349c3bf8&"
import script from "./CompanyEventTable.vue?vue&type=script&lang=ts&"
export * from "./CompanyEventTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports